import { render, staticRenderFns } from "./userConfiguration_DELETE.vue?vue&type=template&id=77b6b784"
import script from "./userConfiguration_DELETE.vue?vue&type=script&lang=js"
export * from "./userConfiguration_DELETE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports